<template>
  <div>
    <input type="checkbox" id="check" />
    <!--header area start-->
    <header>
      <label for="check">
        <i class="fas fa-bars" id="sidebar_btn"></i>
      </label>
      <div class="left_area">
        <h3>expar<span></span></h3>
        <language-switcher class="lang-dashboard" />
      </div>
      <div class="right_area">
        <a v-if="env === 'production'" href="//expar.si" class="logout_btn">
          {{ $t('logout') }}
        </a>
        <a v-else href="//demo.expar.si" class="logout_btn">
          {{ $t('logout') }}
        </a>
      </div>
    </header>
    <!--header area end-->
    <!--mobile navigation bar start-->
    <div class="mobile_nav">
      <div class="nav_bar">
        <img
          v-if="cleanerDetails && cleanerDetails.img_path"
          :src="`${cleanerDetails.img_path}`"
          class="profile_image"
          alt=""
        />
        <img
          v-else
          src="../assets/static/images/shr_logo.png"
          class="profile_image"
          alt=""
        />
        <i class="fa fa-bars nav_btn" @click="isActive = !isActive"></i>
      </div>
      <div
        class="mobile_nav_items"
        v-bind:class="{ active: isActive }"
        @click="isActive = !isActive"
      >
        <!-- <router-link
          :to="'/' + 'cleaner-panel/' + $i18n.locale"
          :class="
            activeTab === 'dashboard' ? 'sidebar_active' : 'sidebar_nonactive'
          "
          @click.native="activeTab = 'dashboard'"
          ><font-awesome-icon icon="tachometer-alt" /><span>{{
            $t('dashboard')
          }}</span></router-link
        > -->
        <router-link
          :to="'/' + 'cleaner-panel/units/' + $i18n.locale"
          :class="
            activeTab === 'units' ? 'sidebar_active' : 'sidebar_nonactive'
          "
          @click.native="activeTab = 'units'"
          ><font-awesome-icon icon="map-marked-alt" /><span>{{
            $tc('unit', 3)
          }}</span>
        </router-link>
        <router-link
          :to="'/' + 'cleaner-panel/profile/' + $i18n.locale"
          :class="
            activeTab === 'profile' ? 'sidebar_active' : 'sidebar_nonactive'
          "
          @click.native="activeTab = 'profile'"
          ><font-awesome-icon icon="address-card" /><span>{{
            $t('profile')
          }}</span></router-link
        >
        <!-- <router-link :to="{ name: 'metricsCleaner'}"><font-awesome-icon icon="tachometer-alt" /><span>Metrics</span></router-link> -->
        <router-link
          :to="'/' + 'cleaner-panel/settings/' + $i18n.locale"
          :class="
            activeTab === 'settings' ? 'sidebar_active' : 'sidebar_nonactive'
          "
          @click.native="activeTab = 'settings'"
          ><font-awesome-icon icon="cogs" /><span>{{
            $t('settings')
          }}</span></router-link
        >
      </div>
    </div>
    <!--mobile navigation bar end-->
    <!--sidebar start-->
    <div class="sidebar">
      <router-link :to="{ name: 'cleanerPanel' }" class="no-hover">
        <div class="profile_info">
          <img
            v-if="cleanerDetails && cleanerDetails.img_path"
            :src="`${cleanerDetails.img_path}`"
            class="profile_image"
            alt=""
          />
          <img
            v-else
            src="../assets/static/images/shr_logo.png"
            class="profile_image"
            alt=""
          />
          <h4>{{ client.client.name }}</h4>
        </div>
      </router-link>
      <router-link
        :to="'/' + 'cleaner-panel/units/' + $i18n.locale"
        :class="activeTab === 'unit' ? 'sidebar_active' : 'sidebar_nonactive'"
        ><div @click="activeTab = 'unit'">
          <font-awesome-icon
            :title="$tc('unit', 3)"
            class="icon"
            icon="map-marked-alt"
          /><span style="margin-left: 15px; font-size: 1.3em">{{
            $tc('unit', 3)
          }}</span>
        </div>
      </router-link>
      <!-- <router-link
        :to="'/' + 'cleaner-panel/' + $i18n.locale"
        :class="
          activeTab === 'dashboard' ? 'sidebar_active' : 'sidebar_nonactive'
        "
        @click.native="activeTab = 'dashboard'"
        ><div>
          <font-awesome-icon
            :title="$t('dashboard')"
            class="icon"
            icon="tachometer-alt"
          /><span style="margin-left: 15px; font-size: 1.3em">{{ $t('dashboard') }}</span>
        </div>
      </router-link>       -->
      <router-link
        :to="'/' + 'cleaner-panel/profile/' + $i18n.locale"
        :class="
          activeTab === 'profile' ? 'sidebar_active' : 'sidebar_nonactive'
        "
        ><div @click="activeTab = 'profile'">
          <font-awesome-icon
            :title="$t('profile')"
            class="icon"
            icon="address-card"
          /><span style="margin-left: 15px; font-size: 1.3em">{{
            $t('profile')
          }}</span>
        </div>
      </router-link>
      <!-- <router-link :to="{ name: 'metricsCleaner'}"><font-awesome-icon class="icon" icon="tachometer-alt" /><span style="margin-left: 15px; font-size: 1.5em">Metrics</span></router-link> -->
      <router-link
        :to="'/' + 'cleaner-panel/settings/' + $i18n.locale"
        :class="
          activeTab === 'settings' ? 'sidebar_active' : 'sidebar_nonactive'
        "
        ><div @click="activeTab = 'settings'">
          <font-awesome-icon
            :title="$t('settings')"
            class="icon"
            icon="cogs"
          /><span style="margin-left: 15px; font-size: 1.3em">{{
            $t('settings')
          }}</span>
        </div></router-link
      >
    </div>
    <!--sidebar end-->
    <div class="content">
      <div class="card">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'

export default {
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      isActive: false,
      baseUrl: process.env.VUE_APP_API_URL,
      cleanerDetails: null,
      activeTab: 'dashboard',
      tabList: ['dashboard', 'profile', 'units', 'settings'],
      env: ''
    }
  },
  computed: mapState(['client']),
  async mounted() {
    this.env = process.env.NODE_ENV
    this.cleanerDetails = await this.$store.dispatch(
      'cleaner/fetchCleanerDetails'
    )
    const location = window.location.href
    const activePage = location.split('/')
    this.activeTab = activePage[activePage.length - 2]
    if (this.activeTab === 'cleaner-panel') this.activeTab = 'dashboard'
  },
  methods: {
    logout() {
      this.$router.push({ path: '/signedOut/' + this.$i18n.locale })
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="css" scoped>
body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', sans-serif;
}

header {
  z-index: 1;
  position: fixed;
  background: var(--bg-light);
  padding: 20px;
  width: calc(100% - 0%);
  top: 0;
  height: 70px;
}

.lang-dashboard {
  position: absolute;
  right: 220px;
  margin-top: -15px;
}
.right_area {
  top: 50px;
}

.left_area h3 {
  font-family: 'Nasalization', Helvetica, Arial;
  color: var(--white);
  margin: -10px;
  font-size: 22px;
  font-weight: 400;
}

.left_area span {
  color: var(--white);
}

.logout_btn {
  padding: 15px;
  background: var(--bg-superLight);
  text-decoration: none;
  float: right;
  margin-top: -40px;
  margin-right: 20px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  text-transform: uppercase;
  width: 150px;
  height: auto;
  transition-property: background;
}

.logout_btn:hover {
  background: #49535e;
}

.sidebar {
  z-index: 1;
  top: 0;
  background: var(--bg-superLight);
  margin-top: 70px;
  padding-top: 30px;
  position: fixed;
  left: 0;
  width: 250px;
  height: calc(100% - 9%);
  transition: 0.5s;
  transition-property: left;
  overflow-y: auto;
}

.sidebar_active {
  background: var(--bg-light);
  color: var(--primary) !important;
}

.sidebar_nonactive {
  background: var(--bg-superLight);
  color: var(--bg-superLight);
}

.profile_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sidebar .profile_info .profile_image {
  width: 200px;
  height: auto;
  /* border-radius: 100px; */
  margin-bottom: 10px;
}
.mobile_nav .nav_bar .profile_image {
  width: 100px;
  height: auto;
  /* border-radius: 100px; */
  margin-bottom: 10px;
}

.sidebar .profile_info h4 {
  color: var(--white);
  margin-top: 0;
  margin-bottom: 50px;
  font-size: 1.2rem;
}

.sidebar a {
  color: var(--white);
  text-align: left;
  display: block;
  width: 100%;
  line-height: 60px;
  text-decoration: none;
  /* padding-left: 20px; */
  box-sizing: border-box;
  transition: 0.5s;
  transition-property: background;
}

.sidebar a:hover {
  background: var(--bg-light);
}

.sidebar .no-hover:hover {
  background: var(--bg-superLight);
}

.sidebar .icon {
  font-size: 1.9em;
  margin-left: 40px;
  margin-bottom: -5px;
}

label #sidebar_btn {
  z-index: 1;
  color: var(--white);
  position: fixed;
  cursor: pointer;
  left: 20px;
  font-size: 30px;
  margin: 5px 0;
  transition: 0.5s;
  transition-property: color;
}

label #sidebar_btn:hover {
  background: var(--bg-light);
}

#check:checked ~ .sidebar {
  left: -185px;
}

#check:checked ~ .sidebar a span {
  display: none;
}

#check:checked ~ .sidebar a {
  font-size: 10px;
  margin-left: 165px;
  width: 100%;
}

.content {
  width: (100% - 250px);
  margin-top: 60px;
  padding: 20px;
  margin-left: 250px;
  background: url('../assets/static/images/bg.jpg');
  background-repeat: repeat-y;
  background-position: center;
  background-size: cover;
  height: 100vh;
  transition: 0.5s;
  z-index: -1;
}

#check:checked ~ .content {
  margin-left: 60px;
}

#check:checked ~ .sidebar .profile_info {
  display: none;
}

#check {
  display: none;
}

.mobile_nav {
  display: none;
}

.left_area h3 {
  font-weight: 400;
  color: var(--white);
}
.left_area span {
  font-weight: 100;
  color: var(--primaryDark);
}

/* Responsive CSS */
@media screen and (max-width: 500px) {
  .left_area h3 {
    text-align: left;
    margin: 0px;
    font-size: 20px;
    margin-top: -30px;
  }
  .lang-dashboard {
    position: absolute;
    right: 140px;
    margin-top: -10px;
  }
  .right_area {
    position: absolute;
    top: 30px !important;
    right: 20px;
  }
}

@media screen and (max-width: 780px) {
  .sidebar {
    display: none;
  }

  #sidebar_btn {
    display: none;
  }

  .content {
    margin-left: 0;
    margin-top: 0;
    padding: 10px 20px;
    transition: 0s;
    background-repeat: repeat-y !important;
  }

  #check:checked ~ .content {
    margin-left: 0;
  }

  .mobile_nav {
    display: block;
    width: calc(100% - 0%);
  }

  .nav_bar {
    background: var(--bg-light);
    width: (100% - 0px);
    margin-top: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  }

  .nav_bar .mobile_profile_image {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .nav_bar .nav_btn {
    color: var(--white);
    font-size: 22px;
    cursor: pointer;
    transition: 0.5s;
    transition-property: color;
  }

  .nav_bar .nav_btn:hover {
    background: var(--bg-light);
  }

  .mobile_nav_items {
    background: var(--bg-superLight) !important;
    display: none;
  }

  .mobile_nav_items a {
    color: var(--white);
    display: block;
    text-align: left;
    letter-spacing: 1px;
    line-height: 60px;
    text-decoration: none;
    box-sizing: border-box;
    transition: 0.5s;
    padding-left: 60px;
    transition-property: background;
  }
  .mobile_nav_items a:hover {
    background: var(--bg-light);
  }
  .mobile_nav_items .icon {
    padding-right: 10px;
    font-size: 1.4em;
  }
  .mobile_nav_items span {
    padding-left: 10px;
    font-size: 1.4em;
  }
  .logout_btn {
    margin-right: 0px;
    width: 100px;
    margin-top: -15px;
    height: 50px;
  }
  .active {
    display: block;
  }
}
</style>
